import { IResaleItem } from './types'

export const DEFAULT_RESALE: IResaleItem = {
	LegacyID: '',
	Name: '',
	SalesOrganizationID: '',
	Status: 1
}
